import moment from "moment";
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { baseFetch } from "../../config";
import { selectAppointments } from "../../store/appointmentSlice";

function useSubmitSurvey() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const { surveyAppointment } = useSelector(selectAppointments);
  const { hospitalCode } = useSelector(
    (state) => state.hospitalInfo.selectedHospital
  );

  const [storedCurrentInCall] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem('currentInCall'));
    } catch {
      return null;
    }
  });

  const activeAppointment = surveyAppointment || storedCurrentInCall;

  const postData = async ({ surveyQuestions }) => {
    setLoading(true);
    setError(null);
    setData(null);
    try {
      const bodyData = {
        hospitalCode: hospitalCode,
        episodeNumber: activeAppointment?.id,
        appointmentDateTime: moment(
          activeAppointment?.apptDateString
        ).format("YYYY-MM-DD HH:mm:ss.SSS"),
        // appointmentDateTime: moment(
        //   activeAppointment?.apptDateString
        // ).toISOString(),
        appointmentId: activeAppointment?.slotBookingId,
        doctorName: activeAppointment?.careProviderDescription,
        surveyQuestions,
        consultationType: "Telemedicine",
        comments: "The doctor was very professional and thorough.",
        platform: "Web",
        rating: 5,
      };

      const apiResponse = await baseFetch(`api/feedback/survey`, {
        method: "POST",
        body: bodyData,
      });

      if (!apiResponse || !apiResponse.status) {
        throw new Error("Someting went wrong try later !");
      }

      if (apiResponse) {
        setData(apiResponse);
        const selectHospCode = JSON.parse(localStorage.getItem("selectedHopitalInfo")).code;
        console.log("selectHospCode", selectHospCode)
        const currentBookingId = activeAppointment;
        const previousBookingId = currentBookingId?.slotBookingId;
        console.log(`${selectHospCode}-previousBookingId`)
        if(previousBookingId){
          console.log(`${selectHospCode}-previousBookingId`)
          localStorage.setItem(`${selectHospCode}-previousBookingId`, previousBookingId)
        }
      }
    } catch (error) {
      setError("Someting went wrong try later !");
      console.error("Error submitting data:", error);
    } finally {
      setLoading(false);
    }
  };

  return { data, loading, error, submitSurvey: postData };
}

export default useSubmitSurvey;
